import styled, { css } from 'styled-components';
import { mq } from '../../../stylesheets/tools';
import { colorThemes } from '../../../stylesheets/themes';

const shadowSizeDesktop = props => {
  switch (props.shadowSize) {
    case 'xxl':
      return '40px';
    case 'xl':
      return '30px';
    case 'lg':
      return '20px';
    case 'md':
      return '10px';
    default:
      return '0px';
  }
};
const shadowSizeMobile = props => {
  switch (props.shadowSize) {
    case 'xxl':
      return '20px';
    case 'xl':
      return '15px';
    case 'lg':
      return '10px';
    case 'md':
      return '5px';
    default:
      return '0px';
  }
};

const StyledShapedImage = styled.div`
  display: block;
  ${props =>
    props.shadowY === 'top' &&
    css`
      padding-top: ${shadowSizeMobile};
    `};
  ${props =>
    props.shadowY === 'bottom' &&
    css`
      padding-bottom: ${shadowSizeMobile};
    `};

  ${props =>
    props.shadow === 'right' &&
    css`
      padding-right: ${shadowSizeMobile};
    `};
  ${props =>
    props.shadow === 'left' &&
    css`
      padding-left: ${shadowSizeMobile};
    `};

  ${mq('m')} {
    padding-bottom: ${shadowSizeDesktop};

    ${props =>
      props.shadow === 'right' &&
      css`
        padding-right ${shadowSizeDesktop};
      `};
    ${props =>
      props.shadow === 'left' &&
      css`
        padding-left: ${shadowSizeDesktop};
      `};
  }

  .shaped-image__container {
    position: relative;
    width: 100%;
    display: block;

    .shaped-image__background-shape {
      position: absolute;
      width: 100%;
      height: 100%;
      max-width: 100%;
      ${props =>
        props.shadowY === 'top' &&
        css`
          top: -${shadowSizeMobile};
        `};
      ${props =>
        props.shadowY === 'bottom' &&
        css`
          bottom: -${shadowSizeMobile};
        `};
      ${props =>
        props.shadow === 'left' &&
        css`
          left: -${shadowSizeMobile};
        `};
      ${props =>
        props.shadow === 'right' &&
        css`
          right: -${shadowSizeMobile};
        `};
      transform: scale(0.95);
      ${props =>
        (props.colorScheme === 'useGlobal' || !props.colorScheme) &&
        css`
          background-color: ${props.theme.globalTheme.primary};
        `}
      ${props =>
        props.colorScheme &&
        props.colorScheme !== 'useGlobal' &&
        css`
          background-color: ${colorThemes[props.colorScheme].primary};
        `}
      ${props =>
        props.clipForm &&
        css`
          clip-path: ${props.clipForm};
        `};

      ${props =>
        props.shadow &&
        props.shadowY &&
        css`
          transform-origin: ${props.shadowY} ${props.shadow};
        `};

      ${mq('m')} {
        ${props =>
          props.shadowY === 'top' &&
          css`
            top: -${shadowSizeDesktop};
          `};
        ${props =>
          props.shadowY === 'bottom' &&
          css`
            bottom: -${shadowSizeDesktop};
          `};

        ${props =>
          props.shadow === 'right' &&
          css`
            right: -${shadowSizeDesktop};
          `};
        ${props =>
          props.shadow === 'left' &&
          css`
            left: -${shadowSizeDesktop};
          `};
      }
    }

    .shaped-image__form {
      overflow: hidden;
      max-width: 100%;
      width: 100%;
      z-index: 1;
      position: relative;

      ${props =>
        props.clipForm &&
        !props.onlyBackground &&
        css`
          clip-path: ${props.clipForm};
        `};
      ${props =>
        props.hoverEffect &&
        css`
          &:hover .shaped-image__item {
            transform: scale(1.25);
          }
        `};
    }
    .shaped-image__item {
      transition: transform 0.5s ease;
      height: 100%;
      width: 100%;
    }
  }
`;

export default StyledShapedImage;
